
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Pourquoi faire un audit pour optimiser votre référencement Web ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez l'importance d'un audit SEO pour évaluer et optimiser votre référencement Web, attirer plus de visiteurs et améliorer votre visibilité en ligne.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Référencement Web : pourquoi faire un audit SEO ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Cet article vous explique l’importance du référencement Web et la nécessité de réaliser un audit SEO.",
        },
      ],
    };
  },
};
